import { Button as MuiButton, makeStyles } from "@material-ui/core";
import React from "react";
type Props = {
  children: any;
  type: "button" | "reset" | "submit";
  onClick?: React.MouseEventHandler<HTMLButtonElement> | undefined;
  className?: string;
};
const useStyles = makeStyles({
  submitButton: {
    backgroundColor: "#00A9A3",
    borderRadius: "26px",
    color: "#fff",
    width: "195px",
    height: "40px",
    "& .MuiButton-label": {
      fontSize: "14px",
    },
    "&.MuiButton-root:hover": {
      backgroundColor: "#115e67",
    },
  },
});
const QPRButton = (props: Props) => {
  const classes = useStyles();
  return (
    <MuiButton
      type={props.type}
      className={`${classes.submitButton} ${props.className}`}
      onClick={props.onClick}
    >
      {props.children}
    </MuiButton>
  );
};
export default QPRButton;
